import { BrandingType } from '../types';

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes

export const BRANDING_CONFIG: Record<
  BrandingType,
  {
    title: string;
    accept: string;
    label: string;
    tooltip: string;
    allowedExtensions: string[];
  }
> = {
  logo: {
    title: 'Choose your Logo',
    accept: '.png',
    label: 'Logo',
    tooltip: 'File Type: PNG\nFile Size: <4MB',
    allowedExtensions: ['png'],
  },
  letterhead: {
    title: 'Letterhead Image',
    accept: '.jpg,.jpeg',
    label: 'Letterhead',
    tooltip: 'File Type: JPG\nFile Size: <5MB',
    allowedExtensions: ['jpg', 'jpeg'],
  },
  follower: {
    title: 'Page-Follower Image',
    accept: '.jpg,.jpeg',
    label: 'Follower',
    tooltip: 'File Type: JPG\nFile Size: <5MB',
    allowedExtensions: ['jpg', 'jpeg'],
  },
};
